












import Vue from 'vue';

export default Vue.extend({
  components: {
  },

  data() {
    return {
      lemmalistVisible: true,
    };
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.lemmalistVisible = window.matchMedia('(min-width: 980px)').matches;
    },
  },

});
